
import { Toaster } from "react-hot-toast"
import useListadoEmpleadosAdmin from "../hooks/useListadoEmpleadosAdmin"
import Cargando from "./Cargando"
import DataTable from "react-data-table-component"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"


export default function ListadoEmpleadosAdmin() {

    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const { listaAdmin, cargando, buscar, setBuscar, elementosFiltrados, columns
    } = useListadoEmpleadosAdmin()


    if (!objLogueado.permitido) {
        window.location = "/"
        return (<></>)
    }


    return (
        <div>

            <Cargando cargando={cargando} />

            <div className="col-12 col-md-4">
                <input
                    type='search'
                    value={buscar}
                    className='form-control mb-2'
                    onChange={e => setBuscar(e.target.value)}
                    placeholder='Buscar por empleado'
                />
            </div>

            {listaAdmin.length > 0
                && (<DataTable
                    responsive
                    pagination
                    columns={columns}
                    data={elementosFiltrados}
                    noDataComponent='No hay datos para mostrar'
                    progressPending={cargando}
                    highlightOnHover
                    paginationComponentOptions={{
                        rowsPerPageText: 'Filas por página:',
                        rangeSeparatorText: 'de',
                        selectAllRowsItem: true,
                        selectAllRowsItemText: 'Todos',
                        pageText: 'Página'
                    }}
                /> || <p className='lead text-center'>No hay datos para mostrar</p>)}

            <Toaster/>
        </div>
    )
}

